import * as professionalWaitlistStore from './store'

// Chave do namespace Vuex do módulo. Congelada em
// `contracts/juncao-paralela.md` e consumida pela view por `mapGetters` —
// mudar aqui sem mudar lá deixa a tela em branco SEM erro de console.
export const PROFESSIONAL_WAITLIST_NAMESPACE = 'professional-waitlist'

/**
 * Registra o store do módulo na aplicação (chamado por `registerAllModules`,
 * `src/modules/index.js`).
 *
 * ⚠️ Sem esta função na lista de `registerAllModules`, o store existe no disco
 * e NÃO está vivo: `view-lista-espera.vue` faz `mapGetters` de um namespace
 * que não existe, a tela abre em branco e nenhum teste unitário do módulo
 * pega — todos eles montam o store por `createComponentMocks`, nunca o real.
 *
 * Guard de re-registro pelo mesmo motivo de `navegacao-v2/index.js` (teste e
 * hot-reload importam o módulo mais de uma vez, e o segundo `registerModule`
 * emite `[vuex] duplicate namespace`, que o `setup.js` transforma em falha).
 *
 * ⚠️ Mas NÃO por `store.hasModule`: este projeto está em **Vuex 3.1.2** e
 * `hasModule` só existe a partir do 3.2.0 — `typeof store.hasModule ===
 * 'function'` é `false` aqui, então o guard de `navegacao-v2/index.js` é
 * INERTE (medido em 21/09/2026: o teste deste arquivo falhou com
 * `store.hasModule is not a function`). O que funciona na 3.1.2 é olhar o
 * state raiz, que é onde `registerModule` instala o módulo.
 */
export function estaRegistrado(store) {
  const raiz = (store && store.state) || {}
  return Object.prototype.hasOwnProperty.call(
    raiz,
    PROFESSIONAL_WAITLIST_NAMESPACE
  )
}

export function professionalWaitlistModule({ store }) {
  if (estaRegistrado(store)) return
  store.registerModule(PROFESSIONAL_WAITLIST_NAMESPACE, {
    ...professionalWaitlistStore,
    namespaced: true,
  })
}
